import CardVM from 'view_models/common/course/card/card-vm';
import GradeBreakdownChart from 'libs/grade-breakdown-chart';
import InstructorCarousel from 'view_models/common/instructor-carousel';

export default function(data) {
  var self = this;
  self.selectedOffering = ko.observable();
  self.showSSORegister = ko.observable(false);
  self.showSSOLogin = ko.observable(false);
  self.showSignup = ko.observable(false);
  self.showLogin = ko.observable(false);
  self.enrollment_type = ko.observable('certificate');
  self.skipEnrollmentSelection = ko.observable(false);
  self.$el = $('#course_info');
  self.recaptcha_site_key = $('#recaptcha-site-key-json').val();

  self.just_registered = false;
  self.current_modal = null;

  self.course = ko.observable();
  self.newuser = ko.observable({
    first_name: ko.observable(),
    last_name: ko.observable(),
    email: ko.observable(),
    password: ko.observable(),
    password_confirmation: ko.observable(),
    agreed_to_terms_and_privacy: ko.observable(),
    recaptcha_token: ko.observable()
  });

  self.enrollment_fields_info = ko.observable({});

  self.loginuser = ko.observable({
    email: ko.observable(),
    password: ko.observable()
  });

  self.justEnrolled = ko.observable(false);

  self.bindData = function (data) {
    var mapping = {
      'related_courses': {
        create: function(options) {
          return new CardVM(options.data, self);
        }
      }
    };

    var mapped_course = ko.mapping.fromJS(data, mapping);
    self.course(mapped_course);
    self.course().sharing = ko.observable(false);
    self.selectedOffering.subscribe(self.switchOffering);

    var skipEnrollment = Kadenze.Util.getParameterByName('simple');
    if (!skipEnrollment && $('#js-simple-enroll').val()) {
      skipEnrollment = true;
    }
    console.log('Skip Enrollment:', skipEnrollment);
    if (
      skipEnrollment ||
        self.course().program_only() == true ||
          self.course().is_micro_course() ||
            Kadenze.isKannu
    ) {
      self.skipEnrollmentSelection(true);
    }
    console.log('skipEnrollmentSelection:', self.skipEnrollmentSelection());

    self.showSSORegister(self.course().sso_enabled());
    self.showSignup(!self.course().sso_enabled());

    var enrollment_type = Kadenze.Util.getParameterByName('type');
    if (!enrollment_type && $('#js-enrollment-type').val()) {
      enrollment_type = $('#js-enrollment-type').val();
    }
    if (enrollment_type) {
      console.log('Enrollment type: ', enrollment_type);
      self.enrollment_type(enrollment_type);
    }
    else if (self.course().current_user && self.course().current_user.is_premium()) {
      self.enrollment_type('certificate');
    }

    _.each(self.course().enrollment_fields(), function(field) {
      if (self.course().current_user && self.course().current_user.for_credit_info) {
        self.enrollment_fields_info()[field.user_attribute()] = self.course().current_user.for_credit_info[field.user_attribute()] || null;
      }
      self.enrollment_fields_info()[field.user_attribute()] = null;
    });

    var action = Kadenze.Util.getParameterByName('action');
    var cookie = $.cookie('register.oauth');
    if (action && action == 'register') {
      self.enrollOrRegister();
    } else if (cookie) {
      self.enrollOrRegister();
      $.removeCookie('register.oauth');
      Kadenze.WebApp.fbEventTrack('CompleteRegistration', {
        content_name:self.course().name()
      });
      ga('send', { hitType: 'event', eventCategory: 'account',
        eventAction: 'CompleteRegistration', eventLabel: self.course().name()
      });
    }

    setTimeout(self.initRelatedCarousel, 500);
  };

  self.switchOffering = function(offering) {
    Kadenze.Request.pjax({
      url: Kadenze.Routes.course_info_path(offering.slug()),
      container: $('#main-pjax-container')
    });
  };

  self.hasEnrollmentFields = function() {
    return self.course() && self.course().enrollment_fields().length > 0;
  };

  self.enrollment_fields_group = ko.computed(function() {
    if (!self.course())
      return {};
    return _.groupBy(self.course().enrollment_fields(), function(field) {
      return field.section();
    });
  });

  self.forCreditInfo = function(attrObs) {
    return ko.computed({
      read: function() {
        return self.enrollment_fields_info()[attrObs()] || null;
      },
      write: function(val) {
        self.enrollment_fields_info()[attrObs()] = val;
        self.enrollment_fields_info.valueHasMutated();
      }
    });
  };

  self.notifyMe = function() {
    var btn = $('#notify-btn')[0];
    var loader = Ladda.create(btn);
    loader.start();
    var req = Kadenze.AjaxRequest({
      url: Kadenze.Routes.notify_me_course_path(self.course().id())
    });

    req.done(function(response) {
      new Kadenze.Notice.success({message: response.message});
      $(btn).fadeOut();
    });

    req.fail(function(data) {
      new Kadenze.Notice.error({message: data.responseJSON.message});
    });

    req.always(function() {
      loader.stop();
    });
  };

  self.trackEnrollment = function(enrollmentType) {
    console.log('tracking enrollment');
    if (enrollmentType && enrollmentType == 'credit') {
      ga('send', { hitType: 'event', eventCategory: 'enrollment',
        eventAction: 'enroll_as_credit_eligible', eventLabel: self.course().name()
      });
    }
    else {
      ga('send', { hitType: 'event', eventCategory: 'enrollment',
        eventAction: 'enroll', eventLabel: self.course().name()
      });
    }

    Kadenze.WebApp.fbEventTrack('Lead', {
      content_name: self.course().name(),
      content_category: enrollmentType == 'program' ? 'Program' : 'Course'
    });
    ga('send', { hitType: 'event', eventCategory: enrollmentType,
      eventAction: 'Lead', eventLabel: self.course().name()
    });

    var tracking_data = { source_medium: 'course_info', new_role: enrollmentType };
    Kadenze.Analytics.track('student_ui', 'enrollment_started', tracking_data);
    return true;
  };

  self.removeStudent = function (item, event) {
    var url = self.course().current_user.unenroll_path();
    var method = 'DELETE';
    var deletePrompt = $(event.currentTarget).data('xconfirm');

    Kadenze.UIUtil.confirmAction(deletePrompt, function () {
      Kadenze.UIUtil.makeRequest(url, method, null, self.$el, null, function (data, textStatus, xhr) {
        self.course().current_user.is_student(false);
        self.course().current_user.is_instructor(false);
        self.course().restricted() ? self.course().current_user.is_pending(false) : self.course().current_user.is_enrolled(false);
        new Kadenze.Notice.success({ message: data.message });
      }, function (xhr, textStatus, errorThrown) {
        self.server_errors(xhr.responseJSON);
      });
    });
  };

  self.initializeVideo = function() {
    var $vidWrapper = $('#vid-player');
    var promo_vid = self.course().course_promo_video;
    if (promo_vid) {
      var vid = promo_vid;
      var mediaUrls = {
        h264_360_url: vid.h264_360_url ? vid.h264_360_url() : '',
        h264_720_url: vid.h264_720_url ? vid.h264_720_url() : ''
      };

      var mediaSubtitles = ko.toJS(vid.subtitles);

      var opts = {
        poster: self.course().cinema_logo(),
        displayMode: 'gallery'
      };
      vid.renderer = new Kadenze.VideoPlayer($vidWrapper, mediaUrls, 'vjs-student-skin', mediaSubtitles, null, opts);
      _.each(mediaSubtitles,function(sub){vid.renderer.addTextTrack(sub);});
    }
  };

  self.initRelatedCarousel = function() {
    // init the recommended courses carousel
    var carouselConfig__recommended_courses = {
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: true,
      autoplay: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ],
      prevArrow: JST['templates/carousel-control__generic']({control_type: 'prev' }),
      nextArrow: JST['templates/carousel-control__generic']({control_type: 'next' })
    };
    var setTabIndexes = function(){
      $carousel__recommended_courses.find('.slick-slide').find('a').attr('tabindex', '-1');
      $carousel__recommended_courses.find('.slick-slide.slick-active').find('a.kd-card__entry-thumb_link, .kd-card__footer_secondary > a').attr('tabindex', '');
    };
    var $carousel__recommended_courses = $('.js-carousel_recommended-courses');
    $carousel__recommended_courses.on('init', function(slick){
      setTabIndexes();
      $carousel__recommended_courses.find('.slick-dots li').attr('aria-hidden', 'false');
      $carousel__recommended_courses.find('.slick-list').attr('aria-live', 'off');
      $carousel__recommended_courses.find('.slick-list').attr('tabindex', '-1');
      $carousel__recommended_courses.find('button.carousel-control__generic--prev').prependTo($carousel__recommended_courses);
      $carousel__recommended_courses.find('.slick-dots button').prepend('carousel page');
    });
    $carousel__recommended_courses.on('afterChange', function(event, slick, currentSlide){
      setTabIndexes();
      $carousel__recommended_courses.find('.slick-dots li').attr('aria-hidden', 'false');
    });

    $carousel__recommended_courses.slick(carouselConfig__recommended_courses);

    setTimeout(Kadenze.UIUtil.initLazyImageLoading(), 100);
  };

  self.buildChart = function() {
    setTimeout(function(){GradeBreakdownChart.init('horizontal');}, 300);
  };

  self.initTabs = function() {
    $('li.tab-subnav__tab:first-child a').tab('show');
  };

  self.userPresent = function() {
    return self.course().current_user || self.just_registered;
  };

  self.showModal = function(modalSelector) {
    if (self.current_modal) {
      self.current_modal.modal('hide');
    }
    self.current_modal = $(modalSelector);
    self.current_modal.modal('show');
  };

  self.enrollMicroCourse = function(vm, evt) {
    const enrollmentType = self.course().credit_cost_cents() ?
      'purchase_only' : 'certificate'
    self.enrollment_type(enrollmentType);
    self.enroll(vm, evt);
  };

  self.enrollOrRegister = function() {
    if (self.userPresent() && !Kadenze.UIUtil.isMobileApp()) {
      Kadenze.Analytics.mpTrack(
        'Start Enrollment Process',
        self.courseTrackingData()
      );

      if (self.course().program_only()) {
        self.enrollment_type('program');
        self.handleEnrollmentRequest(null, null);
      } else if (self.course().is_micro_course()) {
        self.enrollMicroCourse();
      } else {
        self.showEnrollOptions();
      }

    } else if (
      self.userPresent() &&
        Kadenze.UIUtil.isMobileApp() &&
          !self.course().program_only()
    ) {
      self.handleEnrollmentRequest(null, null);

    } else {
      self.showRegisterOptions();
    }
  };

  self.showEnrollOptions = function() {
    if (self.skipEnrollmentSelection()) {
      self.handleEnrollmentRequest(null, null);
    } else {
      self.showModal('#js-course-enroll-modal--options');
      Kadenze.WebApp.initFormElements($('#js-course-enroll-modal--options'));
      Kadenze.Analytics.mpTrack('Enrollment Options Displayed', self.courseTrackingData());
    }
  };

  self.showRegisterOptions = function() {
    self.showModal('#js-course-enroll-modal--authenticate');
    Kadenze.Analytics.mpTrack('Register Modal Displayed', self.courseTrackingData());
  };

  self.showCertificateInfo = function() {
    self.showModal('#js-certificate-info-modal');
    Kadenze.Analytics.mpTrack('Certificate Info Modal Displayed', self.courseTrackingData());
  };

  self.showProgramInfo = function() {
    self.showModal('#js-program-info-modal');
    Kadenze.Analytics.mpTrack('Program Info Modal Displayed', self.courseTrackingData());
  };

  self.showCreditInfo = function() {
    self.showModal('#js-credit-info-modal');
    Kadenze.Analytics.mpTrack('Credit Info Modal Displayed', self.courseTrackingData());
  };

  self.showMicroCourseInfo = function() {
    self.showModal('#js-microcourse-info-modal');
    Kadenze.Analytics.mpTrack('Microcourse Info Modal Displayed', self.courseTrackingData());
  };

  self.submitEnrollmentFields = function(vm, evt) {
    var loader = Ladda.create(evt.target);

    loader.start();

    Kadenze.Analytics.mpTrack('Submit Enrollment Fields', self.courseTrackingData());

    if (self.course().current_user && self.course().current_user.for_credit_info) {
      var data = {user: {for_credit_info: ko.mapping.toJS(self.course().current_user.for_credit_info)} };
      data.user.for_credit_info = _.extend(data.user.for_credit_info, ko.mapping.toJS(self.enrollment_fields_info));
    } else {
      var data = {user: {for_credit_info: ko.mapping.toJS(self.enrollment_fields_info)}};
    }

    var req = new Kadenze.AjaxRequest({
      type: 'PUT',
      url: Kadenze.Routes.users_path(),
      data: data
    });

    req.done(function(res) {
      self.enroll(vm, evt);
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.errors;
      }
      new Kadenze.Notice.error({message: msg});
    });

    req.always(function() {
      loader.stop();
    });
  };

  self.register = function(vm, evt) {
    var loader = Ladda.create(evt.target);
    loader.start();

    if (self.recaptcha_site_key && Kadenze.isKadenze) {
      grecaptcha.enterprise.ready(function() {
        grecaptcha.enterprise.execute(self.recaptcha_site_key, { action: 'external_imports' }).then(function(token) {
          self.newuser().recaptcha_token(token); // Set the token in the newuser object
          submitRegistrationRequest();
        });
      });
    } else {
      submitRegistrationRequest();
    }

    function submitRegistrationRequest() {
      // Retrieve the user registration data from the observable object
      var userRegistrationData = ko.mapping.toJS(self.newuser);

      var req = new Kadenze.AjaxRequest({
        type: 'POST',
        url: Kadenze.Routes.user_registration_path(),
        data: { user: ko.mapping.toJS(self.newuser) }
      });

      req.done(function(res) {
        self.just_registered = true;
        Kadenze.Analytics.mpTrack('Register', _.extend({}, self.courseTrackingData(), {auth_type: 'email'}));
        // set the course current user
        self.showEnrollOptions();
        if (Kadenze.ENVIRONMENT === 'prod' && Kadenze.isKadenze) {
          Kadenze.WebApp.onFbLoaded(() => {
            fbq('init', '483925218455659', {
              em: res.resource.email.toLowerCase(),
              fn: res.resource.first_name.toLowerCase(),
              ln: res.resource.last_name.toLowerCase()
            });
            Kadenze.WebApp.fbEventTrack('CompleteRegistration', {
              content_name:self.course().name()
            });
            ga('send', { hitType: 'event', eventCategory: 'account',
              eventAction: 'CompleteRegistration', eventLabel: self.course().name()
            });
          });
        }
      });

      req.fail(function(xhr, status, msg) {
        if (xhr.responseJSON) {
          msg = xhr.responseJSON.errors;
        }
        new Kadenze.Notice.error({message: msg});
      });

      req.always(function() {
        loader.stop();
      });
    }
  };

  self.login = function(vm, evt) {
    var loader = Ladda.create(evt.target);
    loader.start();
    var req = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.user_session_path(),
      data: { user: ko.mapping.toJS(self.loginuser) }
    });

    req.done(function(res) {
      self.just_registered = true;

      Kadenze.Analytics.mpTrack(
        'Login',
        _.extend(
          {},
          self.courseTrackingData(),
          { auth_type: 'email' }
        )
      );

      if (res.csrf)
        $('meta[name=\'csrf-token\']').prop('content', res.csrf);

      if (res.course_ids && _.contains(res.course_ids, self.course().id())) {
        // already enrolled
        window.location = Kadenze.Routes.course_info_path(self.course().id());
      } else if (self.course().is_micro_course()) {
        self.enrollMicroCourse(vm, evt);
      } else {
        loader.stop();
        self.showModal('#js-course-enroll-modal--options');
      }
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.error;
      }
      new Kadenze.Notice.error({message: msg});
      loader.stop();
    });

  };

  self.handleEnrollmentRequest = function(vm, evt) {
    if(Kadenze.UIUtil.isMobileApp()) {
      let enrollment_type = self.userPresent().is_premium() ?
        'certificate' : 'auditor';
      self.enrollment_type(enrollment_type);
      self.enroll(vm, evt);
    } else {
      if (
        self.hasEnrollmentFields() &&
          (self.enrollment_type() == 'credit' ||
            self.enrollment_type() == 'program')
      ) {
        self.showModal('#js-course-enroll-modal--fields');
      } else if (self.course().is_micro_course()) {
        self.enrollMicroCourse(vm, evt);
      } else {
        self.enroll(vm, evt);
      }
    }
  };

  self.enroll = function(vm, evt) {
    if (evt) {
      var loader = Ladda.create(evt.target);
      loader.start();
    }

    self.trackEnrollment(self.enrollment_type());
    Kadenze.Analytics.mpTrack('Submit Enrollment Request', _.extend({}, self.courseTrackingData(), {enrollment_type: self.enrollment_type()}));

    var req = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.course_enroll_path(self.course().id()),
      data: { type: self.enrollment_type() }
    });

    req.done(function(res) {
      if (res && res.redirect_path) {
        window.location.pathname = res.redirect_path;
      }
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.errors;
      }
      new Kadenze.Notice.error({message: msg});
      if (loader) {
        loader.stop();
      }
    });

  };

  self.toggleSharePanel = function() {
    Kadenze.Analytics.mpTrack('Share Panel Shown', self.courseTrackingData());
    self.course().sharing(!self.course().sharing());
  };

  self.showShareModal = function (item, event) {
    var params = { shareableObj: { share_url: self.course().share_url() } }
    var modal = new Kadenze.ShareModal(params);
    modal.show();
  };

  self.bindShareEvents = function() {
    // hide the share menu when focus leaves it
    if(!Kadenze.UIUtil.isSafari()) {
      var timeout;
      var $shareMenu = $('.course-cta__share--desktop');
      $shareMenu.on('focus.shareMenu', 'a, input', function(e){
        clearTimeout(timeout);
      });
      $shareMenu.on('blur.shareMenu', 'a', function(e){
        timeout = setTimeout(function () {
          self.course().sharing(false);
          $('.course-hero__start-date_share-btn').focus();
        }, 5);
      });
      $('.course-hero__start-date_share-btn').on('blur.shareMenu', function() {
        timeout = setTimeout(function () {
          self.course().sharing(false);
        }, 5);
      });
    }
    // hide the share menu on esc keypress
    $(document).off('keyup.shareMenu').on('keyup.shareMenu', function(event) {
      if(event.which == 27){
        self.course().sharing(false);
        $('.course-hero__start-date_share-btn').focus();
      }
    });
  };

  self.emailShareCourse = function(item, emails) {
    Kadenze.Analytics.mpTrack('Course E-mail Share Submitted', _.extend({}, self.courseTrackingData(), {email_count: emails.length}));
    // var request = new Kadenze.AjaxRequest({
    //   type: 'PATCH',
    //   url: Kadenze.Routes.share_course_path(item.id()),
    //   data: {emails: emails}
    // });

    // request.done(function(res) {
      new Kadenze.Notice.success({
        message: 'This feature is not available for now.'
      });
    // });

    // request.fail(function(xhr, status, msg) {
    //   if (xhr.responseJSON)
    //     msg = xhr.responseJSON.message;

    //   new Kadenze.Notice.error({message: msg});
    // });
  };

  self.scrollToInstructor = InstructorCarousel.scrollToInstructor

  self.initSSOEvents = function() {
    $('#email-register-btn').click(function() {
      self.showSSORegister(false);
      self.showSSOLogin(false);
      self.showSignup(true);
    });

    $('#email-login-btn').click(function() {
      self.showSSORegister(false);
      self.showSSOLogin(false);
      self.showLogin(true);
    });

    $('.js-oauth-btn').click(function() {
      let evtType = self.showSSOLogin() ? 'Begin Login' : 'Begin Register';
      Kadenze.Analytics.mpTrack(evtType, _.extend({}, self.courseTrackingData(), {auth_type: 'oauth', provider: $(this).data('oauth-type') }));
      $.cookie('register.oauth', true, { expires: 1 });
    });
  };

  self.courseTrackingData = function() {
    let mapping = {
      'ignore': ['course_promo_video']
    };
    return ko.mapping.toJS(self.course, mapping);
  };


  const __construct = function (that) {
    console.log('constructor called for CourseInfoViewModel');
    Kadenze.Analytics.mpTrack('Course Public Info View', self.courseTrackingData());
    that.bindData(data);
    that.buildChart();
    that.initializeVideo();
    that.initTabs();
    that.bindShareEvents();
    that.initSSOEvents();
    Kadenze.Share.init();

    Kadenze.UIUtil.initMultilineTruncation();
  }(this);
}
